import React, {useContext} from 'react'
import {CustomerContext} from '../../CustomerContext'
import BaseReportPane from '@/app/modules/p2c/dashboard/components/panes/OrderReportPane'

const OrderReportPane = () => {
  const { customer } = useContext(CustomerContext)

  if (!customer) {
    return (<></>)
  }

  return (
    <BaseReportPane customer={customer} />
  )
}

export default OrderReportPane
